import { CheckmarkOutlined } from '@icon';
import React from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

interface ListItemStateProps {
  Icon?: (p: React.SVGProps<SVGSVGElement>) => JSX.Element;
  state?: 'checked' | 'success' | 'error' | 'waiting';
  style?: React.CSSProperties;
  className?: string;
}

function getColor(state: ListItemStateProps['state'], theme: DefaultTheme) {
  switch (state) {
    case 'checked':
      return theme.color.tint.selection;
    case 'success':
      return theme.color.solid.success;
    case 'error':
      return theme.color.solid.error;
    case 'waiting':
      return theme.color.solid.info;
    default:
      return theme.color.surface.secondary;
  }
}

const ListItemState: React.FunctionComponent<ListItemStateProps> = ({
  Icon = CheckmarkOutlined,
  state = 'checked',
  style,
  className,
}) => {
  const theme = useTheme();

  return (
    <Icon
      className={className}
      width={20}
      height={20}
      color={getColor(state, theme)}
      style={Object.assign({ marginLeft: 16 }, style)}
    />
  );
};

export default ListItemState;
